













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FounderConsultDto } from '@/dto';
@Component
export default class SpaceInfoCard extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly loading: boolean;
  @Prop() readonly founderConsultDto: FounderConsultDto;
}
